import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { LocalizedMessage, standardDateOptions } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Models
import mInstallationLog from 'models/installationLog';
// Custom
import { openDialog, getInstallationLogsList } from 'actions';
import { fullListShape } from 'constants/PropTypesShapes';
import SubListTemplate from 'components/templates/SubListTemplate';
import withResources from 'installations/assets/hocs/WithResources';
import LogRow from 'installations/assets/logs/LogRow';
import LogFilters from 'installations/assets/logs/LogFilters';
import withEntitiesInformation from 'installations/assets/hocs/WithEntitiesInformation';
import { OpacInstallationContext } from 'components/misc/Contexts';

class LogsList extends React.Component {
  constructor(props) {
    super(props);

    this.handleDisplayLogInfo = this.handleDisplayLogInfo.bind(this);
    this.doGetRowComp = this.doGetRowComp.bind(this);
  }

  // Handlers
  handleDisplayLogInfo(log) {
    const { intl, handleOpenDialog } = this.props;
    handleOpenDialog({
      title: {
        id: 'title.accessLog',
        values: {
          date: intl.formatDate(log.date, standardDateOptions),
        },
      },
      actions: [
        { type: 'close' },
      ],
      component: {
        type: 'INSTALLATION_LOG_INFO',
        props: {
          log,
        },
      },
      size: 'md',
    });
  }

  // Private
  doGetRowComp(props) {
    const { params } = this.props;
    return (
      <LogRow
        {...props}
        installationId={params.id}
        onDisplayLogInfo={this.handleDisplayLogInfo}
      />
    );
  }

  render() {
    const {
      logs, params, desynchronized, hasMultipleEntities, handleGetLogsList,
    } = this.props;

    // No entity filter if user has not multiple entities
    const excludedFilterFields = [];
    if (!hasMultipleEntities) {
      excludedFilterFields.push('entityId');
    }

    const { timezone } = this.context;

    return (
      <SubListTemplate
        title={
          <LocalizedMessage id="title.accessesList" />
        }
        name={mInstallationLog.name}
        listFeatures={mInstallationLog.listFeatures}
        withActions
        nbActions={2}
        displayRefresh
        elementsData={{
          loading: logs.loading,
          desynchronized,
          elements: logs.elements,
          handleGetList: (pagination, sort, filters) => handleGetLogsList(params.id, pagination, sort, filters, desynchronized),
        }}
        withAutoRefresh
        defaultAutoRefresh={false}
        excludedFilterFields={excludedFilterFields}
        filtersComp={
          <LogFilters id={params.id} timezone={timezone} />
        }
        rowComp={this.doGetRowComp}
      />
    );
  }
}

LogsList.contextType = OpacInstallationContext;

LogsList.propTypes = {
  intl: PropTypes.object.isRequired,
  params: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  logs: fullListShape.isRequired,
  desynchronized: PropTypes.bool.isRequired,
  hasMultipleEntities: PropTypes.bool.isRequired,
  handleOpenDialog: PropTypes.func.isRequired,
  handleGetLogsList: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  logs: state.installationLog.list,
  desynchronized: state.installationLog.list.desynchronized,
});

const mapDispatchToProps = (dispatch) => ({
  handleOpenDialog: (props) => {
    dispatch(openDialog(props));
  },
  handleGetLogsList: (id, pagination, sort, filters, desynchronized) => {
    dispatch(getInstallationLogsList(id, pagination, sort, filters, desynchronized));
  },
});

module.exports = compose(
  withResources(
    (ownProps) => ({ id: ownProps.params.id }),
    ['doors', 'sources', 'devices', 'scenarios'],
  ),
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withEntitiesInformation,
)(LogsList);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/show/routes/logs/routes/index/components/InstallationLogsList.js